import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ForwardOnHoverDirective } from './forward-on-hover.directive';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [ForwardOnHoverDirective],
  exports: [ForwardOnHoverDirective]
})
export class ForwardOnHoverModule { }
